import { Application, Container } from 'pixi.js';
import { renderSnowflakeEffect } from './renderSnowflakeEffect.ts';
import { renderHeartEffect } from './renderHeartEffect.ts';
import { renderLightingEffect } from './renderLightingEffect.ts';
import { Effect } from '../../../types/typing.ts';

export type EffectContainer = Container & {
  id?: string;
  cleanup?: () => void;
};

const disablePointerEvents = (container: EffectContainer) => {
  const applyPointerPassThrough = (target: any) => {
    target.eventMode = 'none';
    target.interactive = false;
    target.children?.forEach(applyPointerPassThrough);
  };

  applyPointerPassThrough(container);
};

export const renderEffects = async (
  app: Application | null,
  effects: Effect[] | null | undefined,
  width: number,
  height: number,
  zIndex: number,
  effectsSpriteRef: any
): Promise<EffectContainer[]> => {
  if (!effects || !app?.stage) return [];

  const renderedContainers: EffectContainer[] = [];
  const addRenderedContainer = (container: EffectContainer) => {
    const stage = app?.stage;

    if (!stage) {
      container.cleanup?.();
      container.destroy({ children: true });
      return false;
    }

    disablePointerEvents(container);
    container.zIndex = zIndex;
    stage.addChild(container);
    stage.sortChildren();
    renderedContainers.push(container);
    return true;
  };

  for (const eff of effects) {
    switch (eff.type) {
      case 'Snowflake':
        const snowflakeSprites = await renderSnowflakeEffect(
          app,
          width,
          height,
          eff.id,
          effectsSpriteRef
        );
        addRenderedContainer(snowflakeSprites);
        break;
      case 'Heart':
        const heartSprites = await renderHeartEffect(
          app,
          width,
          height,
          eff.id,
          effectsSpriteRef
        );
        addRenderedContainer(heartSprites);
        break;
      case 'Lighting':
      case 'Sunlight':
        const lightingSprites = await renderLightingEffect(
          app,
          width,
          height,
          eff.id,
          effectsSpriteRef
        );
        addRenderedContainer(lightingSprites);
        break;
      default:
        console.error('Unknown effect:', eff);
    }
  }

  return renderedContainers;
};
